<template>
    <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist'>
                    <div class="bmk">
                        我要咨询
                    </div>
                    <div class="mainSty">
                        <van-field @input="getFieldValue" v-model="message" rows="10" autosize type="textarea" maxlength="200" ref="rectVan" placeholder="您的咨询让我们做的更好..." />
                        <div style="display:flex;align-items:left;" class="imguf">
                            <div v-for="(item,index) in imgArr" :key="index" class="pblkd">
                                <img :src="item.src" style="flex:1;width:100%;height:100%">
                                <img :src="item.delSrc" :id="item.id" class="imgup" @click='delImage($event)' />
                            </div>
                            <div style="flex:0 0 25%;height:100%;">
                                <van-uploader :before-read="beforeRead" :after-read="afterRead" :max-count="3" style="position:absolute;height:100%;width:100%">
                                    <!-- <van-uploader :after-read="afterRead" :max-count="3"> -->
                                    <img src="./image/image@2x.png" class="imgtp" style="position:absolute;top:0;left:0" />
                                </van-uploader>
                            </div>
                        </div>
                        <div style="display:flex" class="txtlk">
                            <div style="flex:1;text-align:left;">最多上传三张照片</div>
                            <div style="flex:1;text-align:right"><span>{{value}}</span>/<span>{{total}}</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blku">
                <div class="blkt">
                    <div class="btn1" @click="toIndex">返回</div>
                </div>
                <div class="blkt">
                    <!-- <div class="btn2" @click="toSubmit">提交</div> -->
                    <div class="btn2">
                        <button :disabled="disabled" class="btn2" @click="toSubmit">提交</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 		<van-uploader v-model="fileList" multiple style="width:200px;height:300px"/> -->
        <customToast :toastRow="toastRow" :show="toastFlag"></customToast>

    </div>

</template>
<script>
import customToast from "@/components/toast.vue";
export default {
    components: {
        customToast,
    },
    created() {},
    data() {
        return {
            toastFlag: false,
            toastRow: {},
            disabled: false,
            i: 0,
            imgsrc: "",
            imgsrc1: "",
            imgArr: [],
            value: "0",
            total: 200,
            message: "",
            current: "",
            estItem: [],
            file: [],
            fileList: [],
        };
    },
    methods: {
        //上传前压缩图片
        async beforeRead(file) {
            //async await 解决异步问题，
            if (this.imgArr.length > 2) {
                // this.$toast("只能上传三张图片");
                this.toastRow = {
                    selId: 4,
                    title: "只能上传三张图片",
                    text: "只能上传三张图片",
                };
                this.toastFlag = true;
                setTimeout(() => {
                    this.toastFlag = false;
                }, 1500);
            } else {
                this.i = this.i + 1;
                let f = await this.$imgcompress.compressImg(
                    file,
                    file.name,
                    file.type
                );
                this.fileList.push(f);
            }
        },
        afterRead(file) {
            if (this.imgArr.length > 2) {
                // this.$toast("只能上传三张图片");
                this.toastRow = {
                    selId: 4,
                    title: "只能上传三张图片",
                    text: "只能上传三张图片",
                };
                this.toastFlag = true;
                setTimeout(() => {
                    this.toastFlag = false;
                }, 1500);
            } else {
                // this.i=this.i+1;
                // this.fileList.push(file.file)
                this.imgArr.push({
                    id: this.i + 1,
                    src: file.content,
                    delSrc: require("./image/-@2x.png"),
                });
            }
        },
        cliSty(index, e) {
            this.current = index;
        },
        toIndex() {
            this.$router.push("/index");
        },
        toSubmit() {
            if (!this.message) {
                // this.$toast("请输入咨询内容");
                this.toastRow = {
                    selId: 4,
                    title: "请输入咨询内容",
                    text: "请输入咨询内容",
                };
                this.toastFlag = true;
                setTimeout(() => {
                    this.toastFlag = false;
                }, 1500);
                this.$refs.rectVan.focus();
            } else {
                this.disabled = true;
                if (this.fileList.length == 1) {
                    const formData = new FormData();
                    formData.append("file", this.fileList[0]);
                    this.$api
                        .post(`/common/upload`, formData, {
                            headers: { "Content-Type": "multipart/form-data" },
                        })
                        .then((res) => {
                            if (res.data.code == "0000") {
                                this.supportDescribeImage1 = res.data.data;
                                this.file = {
                                    consultBy:
                                        this.$store.state.user.userInfo.userId,
                                    consultByCompany:
                                        this.$store.state.user.userInfo
                                            .companyId,
                                    consultByTel:
                                        this.$store.state.user.userInfo.tel,
                                    consultContent: this.message,
                                    consultImage1: this.supportDescribeImage1,
                                    consultImage2: "",
                                    consultImage3: "",
                                    consultType: 2,
                                };

                                this.$api
                                    .post(
                                        "/app/user/insertComplaint",
                                        this.file
                                    )
                                    .then((res) => {
                                        this.disabled = false;
                                        if (res.data.code == "0000") {
                                            // this.$toasts("提交成功");
                                            this.toastRow = {
                                                selId: 3,
                                                title: "提交成功",
                                                text: "您已成功提交咨询",
                                            };
                                            this.toastFlag = true;
                                            setTimeout(() => {
                                                this.toastFlag = false;
                                            }, 1500);
                                            this.disabled = false;
                                            setTimeout(() => {
                                                this.$router.push("/index");
                                            }, 1000);
                                        }
                                    });
                            }
                        });
                } else if (this.fileList.length == 2) {
                    const formData = new FormData();
                    formData.append("file", this.fileList[0]);
                    this.$api
                        .post(`/common/upload`, formData, {
                            headers: { "Content-Type": "multipart/form-data" },
                        })
                        .then((res) => {
                            if (res.data.code == "0000") {
                                this.supportDescribeImage1 = res.data.data;
                                const formData1 = new FormData();
                                formData1.append("file", this.fileList[1]);
                                this.$api
                                    .post(`/common/upload`, formData1, {
                                        headers: {
                                            "Content-Type":
                                                "multipart/form-data",
                                        },
                                    })
                                    .then((res1) => {
                                        if (res1.data.code == "0000") {
                                            this.supportDescribeImage2 =
                                                res1.data.data;
                                            this.file = {
                                                consultBy:
                                                    this.$store.state.user
                                                        .userInfo.userId,
                                                consultByCompany:
                                                    this.$store.state.user
                                                        .userInfo.companyId,
                                                consultByTel:
                                                    this.$store.state.user
                                                        .userInfo.tel,
                                                consultContent: this.message,
                                                consultImage1:
                                                    this.supportDescribeImage1,
                                                consultImage2:
                                                    this.supportDescribeImage2,
                                                consultImage3: "",
                                                consultType: 2,
                                            };
                                            // this.disabled=true

                                            this.$api
                                                .post(
                                                    "/app/user/insertComplaint",
                                                    this.file
                                                )
                                                .then((res) => {
                                                    this.disabled = false;
                                                    if (
                                                        res.data.code == "0000"
                                                    ) {
                                                        // this.$toasts(
                                                        //     "提交成功"
                                                        // );
                                                        this.toastRow = {
                                                            selId: 3,
                                                            title: "提交成功",
                                                            text: "您已成功提交咨询",
                                                        };
                                                        this.toastFlag = true;
                                                        setTimeout(() => {
                                                            this.toastFlag = false;
                                                        }, 1500);
                                                        setTimeout(() => {
                                                            this.$router.push(
                                                                "/index"
                                                            );
                                                        }, 1000);
                                                    }
                                                });
                                        }
                                    });
                            }
                        });
                } else if (this.fileList.length == 3) {
                    const formData = new FormData();
                    formData.append("file", this.fileList[0]);
                    this.$api
                        .post(`/common/upload`, formData, {
                            headers: { "Content-Type": "multipart/form-data" },
                        })
                        .then((res) => {
                            if (res.data.code == "0000") {
                                this.supportDescribeImage1 = res.data.data;
                                const formData1 = new FormData();
                                formData1.append("file", this.fileList[1]);
                                this.$api
                                    .post(`/common/upload`, formData1, {
                                        headers: {
                                            "Content-Type":
                                                "multipart/form-data",
                                        },
                                    })
                                    .then((res1) => {
                                        if (res1.data.code == "0000") {
                                            this.supportDescribeImage2 =
                                                res1.data.data;
                                            const formData2 = new FormData();
                                            formData2.append(
                                                "file",
                                                this.fileList[2]
                                            );
                                            this.$api
                                                .post(
                                                    `/common/upload`,
                                                    formData2,
                                                    {
                                                        headers: {
                                                            "Content-Type":
                                                                "multipart/form-data",
                                                        },
                                                    }
                                                )
                                                .then((res2) => {
                                                    if (
                                                        res2.data.code == "0000"
                                                    ) {
                                                        this.supportDescribeImage3 =
                                                            res2.data.data;
                                                        this.file = {
                                                            consultBy:
                                                                this.$store
                                                                    .state.user
                                                                    .userInfo
                                                                    .userId,
                                                            consultByCompany:
                                                                this.$store
                                                                    .state.user
                                                                    .userInfo
                                                                    .companyId,
                                                            consultByTel:
                                                                this.$store
                                                                    .state.user
                                                                    .userInfo
                                                                    .tel,
                                                            consultContent:
                                                                this.message,
                                                            consultImage1:
                                                                this
                                                                    .supportDescribeImage1,
                                                            consultImage2:
                                                                this
                                                                    .supportDescribeImage2,
                                                            consultImage3:
                                                                this
                                                                    .supportDescribeImage3,
                                                            consultType: 2,
                                                        };
                                                        // this.disabled=true
                                                        this.$api
                                                            .post(
                                                                "/app/user/insertComplaint",
                                                                this.file
                                                            )
                                                            .then((res) => {
                                                                this.disabled = false;
                                                                if (
                                                                    res.data
                                                                        .code ==
                                                                    "0000"
                                                                ) {
                                                                    // this.$toasts(
                                                                    //     "提交成功"
                                                                    // );
                                                                    this.toastRow =
                                                                        {
                                                                            selId: 3,
                                                                            title: "提交成功",
                                                                            text: "您已成功提交咨询",
                                                                        };
                                                                    this.toastFlag = true;
                                                                    setTimeout(
                                                                        () => {
                                                                            this.toastFlag = false;
                                                                        },
                                                                        1500
                                                                    );
                                                                    setTimeout(
                                                                        () => {
                                                                            this.$router.push(
                                                                                "/index"
                                                                            );
                                                                        },
                                                                        1000
                                                                    );
                                                                }
                                                            });
                                                    }
                                                });
                                        }
                                    });
                            }
                        });
                } else {
                    this.file = {
                        consultBy: this.$store.state.user.userInfo.userId,
                        consultByCompany:
                            this.$store.state.user.userInfo.companyId,
                        consultByTel: this.$store.state.user.userInfo.tel,
                        consultContent: this.message,
                        consultImage1: "",
                        consultImage2: "",
                        consultImage3: "",
                        consultType: 2,
                    };
                    // this.disabled=true
                    this.$api
                        .post("/app/user/insertComplaint", this.file)
                        .then((res) => {
                            this.disabled = false;
                            if (res.data.code == "0000") {
                                // this.$toasts("提交成功");
                                this.toastRow = {
                                    selId: 3,
                                    title: "提交成功",
                                    text: "您已成功提交咨询",
                                };
                                this.toastFlag = true;
                                setTimeout(() => {
                                    this.toastFlag = false;
                                }, 1500);
                                setTimeout(() => {
                                    this.$router.push("/index");
                                }, 1000);
                            }
                        });
                }
            }
        },
        // toSubmit(){
        // 	if(!this.message){
        // 		this.$toast('请输入咨询内容')
        // 		this.$refs.rectVan.focus()
        // 	}else{
        // 		this.file = new FormData()
        // 		if(this.fileList.length==3){
        // 			for(let i=0;i<this.fileList.length;i++){
        // 				this.file.append(`complaint${i+1}`,this.fileList[i])
        // 			}
        // 		}else if(this.fileList.length==2){
        // 			for(let i=0;i<this.fileList.length;i++){
        // 				this.file.append(`complaint${i+1}`,this.fileList[i])
        // 			}
        // 			this.file.append(`complaint3`,'')
        // 		}else if(this.fileList.length==1){
        // 			for(let i=0;i<this.fileList.length;i++){
        // 				this.file.append(`complaint${i+1}`,this.fileList[i])
        // 			}
        // 			this.file.append(`complaint2`,'')
        // 			this.file.append(`complaint3`,'')
        // 		}else if(this.fileList.length==0){
        // 			this.file.append(`complaint1`,'')
        // 			this.file.append(`complaint2`,'')
        // 			this.file.append(`complaint3`,'')
        // 		}
        // 		this.file.append('consultContent',this.message)
        // 		this.file.append('consultBy',this.$store.state.user.userInfo.name)
        // 		this.file.append('consultType','2')
        // 		this.file.append('consultByCompany',this.$store.state.user.userInfo.companyName)
        // 		this.file.append('consultByTel',this.$store.state.user.userInfo.tel)
        // 		this.disabled=true
        // 		this.$api.post('/app/user/insertComplaint',this.file,{headers: {'Content-Type': 'multipart/form-data'}}).then(res=>{
        // 			   this.disabled=false
        // 			   if(res.data.code=="0000"){
        // 				   this.$toasts ('提交成功');
        // 				   setTimeout(()=>{
        // 				   		this.$router.push('/index')
        // 				   },1000)
        // 			   }
        // 			})
        // 	}
        // },
        getFieldValue(e) {
            this.value = e.length;
        },
        delImage: function (e) {
            this.imgArr.forEach((item, index, arr) => {
                if (item.id == e.target.id) {
                    item.src = "";
                    this.fileList.splice(index, 1);
                }
            });
            this.imgArr = this.imgArr.filter((item) => item.src != "");
        },
    },
    watch: {
        value() {},
    },
};
</script>
<style scoped>
::v-deep .van-dialog {
    width: 75% !important;
}
button {
    border: none;
    padding: 0;
    margin: 0;
}
.txtlk {
    position: absolute;
    bottom: 16px;
    left: 13px;
    right: 13px;
    height: 16px;
    font-size: 11px;
    color: #d0d1d4;
}
.imguf {
    position: absolute;
    bottom: 46px;
    left: 13px;
    right: 13px;
    height: 80px;
}
.imgup {
    position: absolute;
    right: -6px;
    top: -6px;
    width: 12px;
    height: 12px;
}
.wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    overflow: hidden;
    overflow-x: hidden;
    background: #e9eef2;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    padding-bottom: 50px;
}
.mainlist {
    width: 100%;
    height: 100%;
}

.mainSty {
    position: relative;
    width: 303px;
    height: 336px;
    padding: 14px 21px;
    margin: 0 auto;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
}
.e_rect {
    width: 68px;
    height: 25px;
    line-height: 25px;
    background: #ffffff;
    border: 1px solid #707070;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #666666;
    margin: 0 auto;
}
.active {
    color: #0080ff;
    border: 1px solid #0080ff;
}
.bmk {
    position: relative;
    width: 100%;
    height: 28px;
    padding: 20px 0;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    color: #101d36;
    line-height: 28px;
}
.imgtp {
    flex: 0 0 25%;
    height: 100%;
    padding: 8px;
    box-sizing: border-box;
    margin: 0 10px;
}
/deep/ .van-uploader__wrapper {
    width: 100%;
    height: 100%;
}
/deep/ .van-uploader__input-wrapper {
    width: 100%;
    height: 100%;
}
/deep/ .van-cell::after {
    border-bottom: 1px solid transparent !important;
}
.blku {
    position: relative;
    display: flex;
    flex-direction: row;
    margin: 0px 20px 20px 20px;
}
.blkt {
    flex: 1;
    display: flex;
    justify-content: center;
}
.btn1 {
    width: 136px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    border: 1px solid #0080ff;
    color: #0080ff;
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
}
.txtu {
    flex: 1;
    text-align: right;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
}
.txtj {
    flex: 1;
    text-align: left;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
}
.txtr {
    flex: 1;
    text-align: right;
    font-size: 12px;
    font-weight: 400;
    color: #333333;
}
.txti {
    flex: 1;
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    color: #333333;
}
.blkn {
    display: flex;
    height: 22px;
    margin-top: 8px;
}
.blkp {
    position: absolute;
    top: 10px;
    left: 0;
    width: 4px;
    height: 13px;
    background: #1aaeff;
}
.blkf {
    position: relative;
    margin: 0 auto;
    padding: 8px 13px;
    background: #fff;
    border-bottom: 1px solid #f2f2f2;
}
.txtg {
    flex: 2;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
}
.txtq {
    flex: 1;
    font-size: 9px;
    font-weight: 400;
    color: #333333;
}
.blkx {
    display: flex;
    align-items: flex-end;
    margin-bottom: 20px;
}
.van-field__word-limit {
    position: absolute;
    bottom: 0;
    right: 0;
}
.blk2 {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
}
.btn2 {
    width: 136px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: linear-gradient(116deg, #36b3fe 11%, #0080ff 91%);
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
}
.pblkd {
    padding: 6px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 25%;
}
</style>
